import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useAppConfigurationPageStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    configurationToolbar: {
        rowGap: tokens.spacingVerticalM,
    },
    tabGroup: {
        minWidth: 0,
        '@media (max-width: 900px)': {
            flexBasis: '100%',
        },
    },
    searchGroup: {
        minWidth: 0,
        '@media (max-width: 900px)': {
            flexBasis: '100%',
        },
    },
    panels: {
        //...shorthands.padding(0, '10px'),
        '& th': {
            textAlign: 'left',
            ...shorthands.padding(0, '30px', 0, 0),
        },
        width: '100%',
        height: '100%',
    },
    tabList: {
        height: 'auto',
        minWidth: 0,
        flexWrap: 'wrap',
        '@media (max-width: 768px)': {
            width: '100%',
        },
    },
    tab: {
        '&::after,&::before': {
            left: '0',
            right: '0',
            bottom: '-8px',
           
        },
        margin: '0px 4px',
        '@media (max-width: 768px)': {
            fontSize: '13px',
            padding: '6px 10px',
            margin: '2px',
        },
    },
    addCrewBtn: {
        marginLeft: tokens.spacingHorizontalM,
        marginRight: tokens.spacingHorizontalM,
    }
});
